<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_ix"></a><a id="frontmatter01"></a>Illustrations</h2>
<p class="toc-entry1"><a href="#/xhtml/chapter01#fig01">Woodlake, Franklin County, Kentucky</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter01#fig02">Madeline and Julia McDowell at Woodlake</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter01#fig03">Madeline McDowell, aged fourteen</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter01#fig04">Henry Clay McDowell Sr. on his Ashland estate</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter01#fig05">Miss Porter’s School in Farmington, Connecticut</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter02#fig06">The McDowell sisters—Julia, Nettie, and Madeline</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter02#fig07">Boot or brace believed to have belonged to Madeline McDowell</a></p>
<p class="toc-entry1"><a href="#/xhtml/chapter02#fig08">Madeline McDowell, early 1890s</a></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#fig09" title="Link target outside of Sample">McDowell family and friends on the steps at Ashland</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#fig10" title="Link target outside of Sample">Desha Breckinridge, 1920</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter03#fig11" title="Link target outside of Sample">Henry Clay McDowell Sr.</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter04#fig12" title="Link target outside of Sample">Madeline McDowell Breckinridge at Ashland</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter04#fig13" title="Link target outside of Sample">The home of Madge and Desha Breckinridge at 337 Linden Walk, Lexington</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter05#fig14" title="Link target outside of Sample">Sophonisba P. Breckinridge</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter06#fig15" title="Link target outside of Sample">Students in a classroom at Lincoln School</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter07#fig16" title="Link target outside of Sample">Excerpt from a pamphlet of the Kentucky Equal Rights Association</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter07#fig17" title="Link target outside of Sample">Outdoor School on the roof of Lincoln School</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter08#fig18" title="Link target outside of Sample">Laura Clay, founder of the Kentucky Equal Rights Association</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter08#fig19" title="Link target outside of Sample">Banner of the Kentucky Equal Rights Association</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter09#fig20" title="Link target outside of Sample">Anne “Nannie” Clay McDowell at Ashland</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter09#fig21" title="Link target outside of Sample">Family gathering at Ashland, May 19, 1917</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter09#fig22" title="Link target outside of Sample">Magdalen Harvey McDowell at Ashland</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter10#fig23" title="Link target outside of Sample">Portrait of Madeline McDowell Breckinridge by Dixie Selden, 1920</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter10#fig24" title="Link target outside of Sample">Governor Edwin P. Morrow signs Kentucky’s ratification of the Nineteenth Amendment</span></p>
<p class="toc-entry1"><span href="#/xhtml/chapter10#fig25" title="Link target outside of Sample">Madeline McDowell Breckinridge by E. Sophonisba Hergersheimer, 1920</span></p>
<p class="toc-entry1"><span href="#/xhtml/backmatter01#fig26" title="Link target outside of Sample">Desha Breckinridge</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?1602bb6e